import Sprite from "./Sprite";
import { TILES } from "../../helpers/tiles";
import { CELL_SIZE } from "../../helpers/consts";
import styles from "./TileElevated.module.css";

export default function ElevatedTile({
  frameCoord,
  size = CELL_SIZE,
  pxAboveGround = 3,
  hover = false,
}) {
  return (
    <div className={styles.tileElevated}>
      <Sprite frameCoord={TILES.SHADOW} />
      <div
        className={`${styles.elevatedContainer} ${hover ? styles.hover : ""}`}
        style={{
          top: pxAboveGround * -1,
        }}
      >
        <Sprite frameCoord={frameCoord} size={size} />
      </div>
    </div>
  );
}
